import React, { useState } from 'react';

import { formatDate } from 'Helpers/dateUtils';
import { formatFigure } from 'Helpers/formatService';

export default function BillOfQuantitiesSimplePacksTable(props) {
    const [showedItems, setShowedItems] = useState({});

    const toggleItems = (id) => {
        const internalShowedItems = { ...showedItems };
        internalShowedItems[id] = !internalShowedItems[id];
        setShowedItems({ ...internalShowedItems });
    };

    return (
        <div>
            <div className={'row mt-3'}>
                <div className={'col-12 px-3'}>
                    <div id={'bill-of-quantities-simple-packs-table'} className={'suppliers-table table-responsive shadow'}>
                        <table className={'my-0 table table-bordered no-footer text-center'}>
                            <thead>
                                <tr className={'text-blue bg-white'}>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-left-0 border-light text-left'}>Department</th>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-light text-left'}>Title</th>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-light text-left'}>Venue</th>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-light text-left'}>Item</th>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-light text-left'}>Date</th>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-light'}>Quantity</th>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-light'}>Unit Cost</th>
                                    <th className={'py-3 border-top-0 border-bottom-0 border-right-0 border-light text-right'}>Total Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.values(props.data).map((department) => {
                                    return (
                                        <React.Fragment key={`bill-of-quantities-simple-packs-table-department-${department['department_id']}`}>
                                            {Object.values(department['titles']).map((title) => {
                                                return (
                                                    <React.Fragment
                                                        key={`bill-of-quantities-simple-packs-table-department-${department['department_id']}-${title['title_id']}`}
                                                    >
                                                        {Object.values(title['data']).map((item) => {
                                                            return (
                                                                <tr
                                                                    key={`bill-of-quantities-simple-packs-table-department-${department['department_id']}-${title['title_id']}-${item['item_id']}-${item['venue_id']}`}
                                                                    className={'bg-grey text-blue'}
                                                                >
                                                                    <td className={'border-bottom-0 border-left-0 border-light text-left'}>
                                                                        {item['department']}
                                                                    </td>
                                                                    <td className={'border-bottom-0 border-light text-left'}>{item['title']}</td>
                                                                    <td className={'border-bottom-0 border-light text-left'}>{item['venue']}</td>
                                                                    <td className={'border-bottom-0 border-light text-left'}>{item['item']}</td>
                                                                    <td className={'border-bottom-0 border-light text-left'}>{formatDate(item['date'])}</td>
                                                                    <td className={'border-bottom-0 border-light'}>
                                                                        {formatFigure(item['quantity'], String, { precision: 4 })}
                                                                    </td>
                                                                    <td className={'border-bottom-0 border-light'}>{formatFigure(item['unit_cost'])}</td>
                                                                    <td className={'border-bottom-0 border-right-0 border-light text-right'}>
                                                                        {formatFigure(item['total_cost'])}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
